module.exports = __webpack_public_path__ + "static/media/system_error.522c999c.svg";